module.exports = __webpack_public_path__ + "media/featured/USAToday-d877a90c.png";